<template>
    <ul role="list" class="mt-8 flex flex-col gap-y-8 text-balance">
        <slot />
    </ul>
</template>
